import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { getReservationsByProductType } from 'utils/helpers';
import { getCurrentBooking } from 'redux/selectors/current_booking';
import { getFirstFerryGrouping } from 'redux/selectors/ui/sealink';
import FerryBooking from './ferry_booking';
import FerryForm from './ferry_form';
import { FerryViewNoData } from './ferry_view';
import UnscheduledFerryBooking from './unscheduled_ferry_booking';

const Ferry = () => {
  const booking = useSelector(getCurrentBooking);
  const journeyForm = useSelector(getFirstFerryGrouping)?.journeyForm || {};
  const ferryReservations = getReservationsByProductType(
    'ferry,transfer',
    booking
  );
  const { pathname } = useLocation();
  const onCheckoutPage = pathname.includes('/bookings/checkout');
  const unscheduledFerries = getReservationsByProductType(
    'unscheduledFerry',
    booking
  );

  if (unscheduledFerries.length) {
    return <UnscheduledFerryBooking />;
  }

  if (!isEmpty(ferryReservations) && onCheckoutPage) {
    return <FerryBooking />;
  }

  // If journeyDates is available, meaning it's a vehicle ferry
  if (journeyForm.journeyDates) {
    return <FerryForm />;
  }

  return <FerryViewNoData />;
};

export default Ferry;
